import { useState } from "react";
import {
  Grid2,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import styles from "./EbsSshDetails.module.scss";
import { EBS_SSH, sshCommand } from "../../../../../../../Utils/roconConstants";
import { copyTextToClipboard } from "../../../../../../../Utils/utils";

/**
 * SSH login of an EBS (v2) site on the Dev Tools page. Host, port and username only: the
 * password was shown once at creation and is not stored anywhere. SSH can only be turned
 * on at creation (no enable/disable/reset job yet), so a site without it just says so.
 */
export default function EbsSshDetails({ sshEnabled, sshHost, sshUsername }) {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const host = sshHost || EBS_SSH.HOST;
  const command = sshCommand(sshUsername, host);

  const copy = async (text) => {
    if (await copyTextToClipboard(text)) setSnackbarOpen(true);
  };

  return (
    <Grid2>
      <TableContainer className={styles.main}>
        <Grid2 className={styles.display}>
          <Grid2 className={styles.header1}>{EBS_SSH.TITLE}</Grid2>
        </Grid2>

        {sshEnabled ? (
          <>
            <Table>
              <TableHead className={styles.tableHead}>
                <TableRow className={styles.tablerow}>
                  <TableCell className={styles.tableHeaderText}>Host</TableCell>
                  <TableCell className={styles.tableHeaderText}>
                    User Name
                  </TableCell>
                  <TableCell className={styles.tableHeaderText}>Port</TableCell>
                  <TableCell className={styles.tableHeaderText}>
                    Command
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow className={styles.row}>
                  <TableCell className={styles.tableBodyText}>{host}</TableCell>
                  <TableCell className={styles.tableBodyText}>
                    {sshUsername}
                  </TableCell>
                  <TableCell className={styles.tableBodyText}>
                    {EBS_SSH.PORT}
                  </TableCell>
                  <TableCell className={styles.tableBodyText}>
                    <span className={styles.commandCell}>
                      <code>{command}</code>
                      <FileCopyOutlinedIcon
                        className={styles.copyIcon}
                        role="button"
                        aria-label="Copy SSH command"
                        onClick={() => copy(command)}
                      />
                    </span>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <Grid2 className={styles.steps}>
              <Grid2 className={styles.stepsTitle}>{EBS_SSH.STEPS_TITLE}</Grid2>
              <ol className={styles.stepList}>
                {EBS_SSH.STEPS.map((step, index) => (
                  <li key={index} className={styles.step}>
                    {step}
                    {index === 1 && (
                      <span className={styles.commandCell}>
                        <code className={styles.commandBox}>{command}</code>
                        <FileCopyOutlinedIcon
                          className={styles.copyIcon}
                          role="button"
                          aria-label="Copy SSH command (steps)"
                          onClick={() => copy(command)}
                        />
                      </span>
                    )}
                  </li>
                ))}
              </ol>
              <Grid2 className={styles.note}>
                {EBS_SSH.PUTTY_NOTE.replace("{host}", host).replace(
                  "{username}",
                  sshUsername || "",
                )}
              </Grid2>
            </Grid2>
            <Grid2 className={styles.note}>{EBS_SSH.PASSWORD_NOTE}</Grid2>
            <Grid2 className={styles.note}>{EBS_SSH.LOCKOUT_NOTE}</Grid2>
          </>
        ) : (
          <Grid2 className={styles.noData}>{EBS_SSH.NOT_ENABLED}</Grid2>
        )}
      </TableContainer>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackbarOpen(false)}
        message="Copied to clipboard"
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      />
    </Grid2>
  );
}
